module.exports = __webpack_public_path__ + "static/media/homebg.1c69d86e.jpg";